<template>
    <div class="nc-contact" @click="$emit('click', item)">
        <div class="nc-contact__img">
            <img v-if="item.logo" :src="item.logo" :alt="customerName" />
            <div v-else class="nc-contact__img-fallback">
                <svg aria-hidden="true" width="24" height="24">
                    <use href="#icon-chat"></use>
                </svg>
            </div>
        </div>

        <div class="nc-contact__body">
            <div class="nc-contact__row">
                <span class="nc-contact__name">{{ customerName }}</span>
                <span v-if="item.date_created" class="nc-contact__date">{{ item.date_created }}</span>
            </div>
            <div class="nc-contact__row">
                <span class="nc-contact__message">{{ item.last_message || '&nbsp;' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewChatHistoryContactItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        customerName() {
            if (!this.item.customer_info) return ''
            return typeof this.item.customer_info === 'object'
                ? this.item.customer_info.text
                : this.item.customer_info
        },
    },
}
</script>